module.exports = __webpack_public_path__ + "static/media/iconmonstr-deezer-5.eab2c8a2.svg";